module.exports = __webpack_public_path__ + "img/ico-pressure-normal-p.0c9ba5a1.png";